import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { removeUserData, setUserData } from '../store/userData/userDataSlice';
import { useDispatch } from 'react-redux';
import { checkEmpty } from '../helpers/utility';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { removeSession, getLoginSession, removeLoginSession, removeUserSessionId } from '../utils';
import FocusTrap from 'focus-trap-react';

import { imageBaseUrl } from '../helpers/constants';

const UserCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    aria-hidden="true"
    className="sign-in-icon"
  >
    <path
      fill="currentColor"
      d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2C149.2 431.4 200.2 464 256 464s106.8-32.6 143-79.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    />
  </svg>
);

const Header = () => {
  const [_loginData, setLoginData] = useState(null);
  const [isModalActive, setIsModalActive] = useState(false);
  const signOutTriggerRef = useRef(null);

  const navigate = useNavigate();

  const isLoggedin = useSelector((state) => state?.userdata?.loggedIn || false);

  const memberType = useSelector((state) => state.userdata.userData?.data?.[0].member_Type || null);

  const dispatch = useDispatch();
  const [toPath, setToPath] = useState('');

  useEffect(() => {
    if (isLoggedin) {
      if (memberType === 'Owner') setToPath('/owner-dashboard');
      else if (memberType === 'Agent') setToPath('/agent-dashboard');
      else if (memberType === 'Member' || memberType === 'Realtors') setToPath('/member-dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedin]);

  const checkSession = () => {
    const data = getLoginSession();
    if (!checkEmpty(data)) {
      dispatch(setUserData(data));
      setLoginData(data?.data[0]);
    } else {
      dispatch(removeUserData());
      setToPath('/');
    }
  };

  useEffect(() => {
    checkSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSignOut = () => {
    setIsModalActive(true);
  };

  const handleCloseClick = () => {
    setIsModalActive(false);
    signOutTriggerRef.current?.focus();
  };

  const handleConfirmClick = () => {
    removeSession();
    dispatch(removeUserData());
    removeLoginSession();
    removeUserSessionId();
    setTimeout(() => navigate('/'), 1000);
    localStorage.removeItem('strategizer_progress');
    setIsModalActive(false);
  };

  return (
    <header>
      <div className="header-sec">
        <div className="container">
          <nav className="navbar navbar-expand-lg" aria-label="Main navigation">
            <div className="main-nav-area">
              <div className="col-lg-3 col-md-4 col-5">
                <Link to="/" className="main-logo" aria-label="Surity Select home">
                  <img
                    className="main-logo-img"
                    src={`${imageBaseUrl}main-logo-2.png`}
                    alt="Surity Select logo"
                    width="158"
                    height="40"
                  />
                </Link>
              </div>
              <div className="col-lg-6 col-md-1">
                <ul className="main-navbar" id="mainNavbar">
                  <li className="menu-item wow fadeInUp" data-wow-delay="0.1s">
                    <Link to="/membership" className="menu-text">
                      Membership
                    </Link>
                  </li>
                  <li className="menu-item wow fadeInUp" data-wow-delay="0.2s">
                    <Link to="/product-plans" className="menu-text">
                      Products &amp; Plans
                    </Link>
                  </li>
                  <li className="menu-item wow fadeInUp" data-wow-delay="0.3s">
                    <Link to="/strategizer" className="menu-text">
                      The Strategizer
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-7 col-7">
                <div className="menu-r-btn-wrapper">
                  <div>
                    {isLoggedin === true ? (
                      <div className="signOut">
                        <button
                          ref={signOutTriggerRef}
                          className="sign-in-btn wow fadeInUp"
                          data-wow-delay="0.4s"
                          onClick={handleSignOut}
                        >
                          <span>Sign Out</span>
                        </button>

                        <Link
                          className="sign-in-btn wow fadeInUp"
                          data-wow-delay="0.4s"
                          to={toPath}
                          aria-label="Go to dashboard"
                        >
                          <UserCircleIcon />
                        </Link>
                      </div>
                    ) : (
                      <Link
                        to="/sign-in"
                        className="sign-in-btn wow fadeInUp"
                        data-wow-delay="0.4s"
                      >
                        <span>Sign In</span> <UserCircleIcon />
                      </Link>
                    )}
                  </div>
                  <div className="ms-4">
                    {isLoggedin === true ? (
                      <></>
                    ) : (
                      <Link
                        to="/join-personal-info"
                        className="theme-btn wow fadeInUp"
                        data-wow-delay="0.5s"
                      >
                        JOIN
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>

      <FocusTrap active={isModalActive}>
        <div
          className={`custom-modal ${isModalActive ? 'active' : ''}`}
          id="signOutModal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="signOutModalTitle"
          aria-hidden={!isModalActive}
        >
          <div className="modal-main-content">
            <div className="modal-inner-content fadeIn">
              <p>
                <button
                  onClick={handleCloseClick}
                  className="modal-close-icon"
                  aria-label="Close sign out dialog"
                >
                  <i className="fas fa-times" aria-hidden="true"></i>
                </button>
              </p>

              <p id="signOutModalTitle" className="modal-subheading text-center">
                Are you sure you want to sign out?
              </p>
              <p className="mt-4 mb-0 text-center">
                <button onClick={handleConfirmClick} className="theme-btn">
                  OK
                </button>
              </p>
            </div>
          </div>
          <div className="black-overlay fadeIn" onClick={handleCloseClick} aria-hidden="true"></div>
        </div>
      </FocusTrap>
    </header>
  );
};

export default Header;
